import { render, staticRenderFns } from "./HeaderProductResale.vue?vue&type=template&id=6a8dca41&scoped=true"
import script from "./HeaderProductResale.vue?vue&type=script&lang=js"
export * from "./HeaderProductResale.vue?vue&type=script&lang=js"
import style0 from "./HeaderProductResale.vue?vue&type=style&index=0&id=6a8dca41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8dca41",
  null
  
)

export default component.exports